import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {usePipelineTemplate} from "../hooks/usePipelineTemplate.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    const {id: pipelineTemplateId} = useParams();

    if (typeof pipelineTemplateId === 'undefined') {
        throw new Error('pipelineTemplateId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = usePipelineTemplate(pipelineTemplateId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
